export default __webpack_public_path__ + "static/media/contact-02.1cade3fc.png";